/**
 * Mobile sort: selection updates only in the overlay; page updates when user
 * clicks Back or Show results (same as filters). Breakpoint 650 matches component-overlay-select.js.
 */
const SORT_MOBILE_BREAKPOINT = 650;

function getActiveSortValue() {
  const active = document.querySelector('.boost-sd__sorting-option--active, .boost-sd__sorting-option[aria-selected="true"]');
  return active && (active.getAttribute('data-value') || active.getAttribute('value'));
}

function setSortOptionActive(option) {
  const list = option && option.closest('.boost-sd__sorting-list');
  if (!list) return;
  list.querySelectorAll('.boost-sd__sorting-option').forEach((o) => {
    o.classList.remove('boost-sd__sorting-option--active');
    o.removeAttribute('aria-selected');
  });
  option.classList.add('boost-sd__sorting-option--active');
  option.setAttribute('aria-selected', 'true');
}

function updateSortValueLabel(option) {
  const sortSection = option && option.closest('.boost-sd__sorting');
  if (!sortSection) return;
  const valueEl = sortSection.querySelector('.boost-sd__sorting-value');
  if (!valueEl) return;
  const val = option.getAttribute('data-value') || option.getAttribute('value');
  const isManual = !val || val === 'manual';
  if (isManual) {
    valueEl.style.display = 'none';
    valueEl.textContent = '';
  } else {
    valueEl.style.display = '';
    valueEl.textContent = option.textContent.trim();
  }
}

/**
 * Match desktop Boost behavior: fetch new URL and replace the same content
 * Boost would update (product list + toolbar). Try Boost container first, then Dawn.
 */
function applySortNoRefresh(url) {
  const boostRight = document.querySelector('.boost-sd-right');
  const dawnContainer = document.getElementById('ProductGridContainer');

  if (boostRight) {
    fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then((res) => { if (!res.ok) throw new Error('Network error'); return res.text(); })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newRight = doc.querySelector('.boost-sd-right');
        if (!newRight) {
          window.location.href = url.toString();
          return;
        }
        boostRight.replaceWith(newRight);
        history.replaceState({}, '', url.toString());
        window.dispatchEvent(new PopStateEvent('popstate'));
      })
      .catch(() => { window.location.href = url.toString(); });
    return;
  }

  if (dawnContainer) {
    fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then((res) => { if (!res.ok) throw new Error('Network error'); return res.text(); })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContainer = doc.getElementById('ProductGridContainer');
        if (!newContainer) {
          window.location.href = url.toString();
          return;
        }
        dawnContainer.replaceWith(newContainer);
        history.replaceState({}, '', url.toString());
        window.dispatchEvent(new PopStateEvent('popstate'));
      })
      .catch(() => { window.location.href = url.toString(); });
    return;
  }

  window.location.href = url.toString();
}

function applySortAndNavigate(e) {
  if (window.innerWidth >= SORT_MOBILE_BREAKPOINT) return;
  const sortVal = getActiveSortValue();
  const url = new URL(window.location.href);
  const currentSort = url.searchParams.get('sort') || '';
  const newSort = sortVal || '';
  const sortChanged = currentSort !== newSort;
  if (sortChanged) {
    e.preventDefault();
    e.stopPropagation();
    if (newSort) url.searchParams.set('sort', newSort);
    else url.searchParams.delete('sort');
    applySortNoRefresh(url);
  }
}

function initMobileSort() {
  if (window.innerWidth >= SORT_MOBILE_BREAKPOINT) return;

  const sortOptions = document.querySelectorAll('.boost-sd__sorting-option');
  sortOptions.forEach((option) => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const value = option.getAttribute('data-value') || option.getAttribute('value');
      if (!value) return;

      setSortOptionActive(option);
      updateSortValueLabel(option);
    });
  });

  ['.boost-sd__button--result', '.boost-sd__button--close'].forEach((sel) => {
    document.body.addEventListener(
      'click',
      (e) => {
        if (!e.target.closest(sel)) return;
        if (window.innerWidth >= SORT_MOBILE_BREAKPOINT) return;
        applySortAndNavigate(e);
      },
      true
    );
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initMobileSort, 2000);
});
